/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CardBase/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'



/** @type {import('Simple/types.js').View} */
export default function CardBase({
  children,
  viewPath = "/DesignSystem/CardBase",
  width = "100%",
  flexDirection = "column",
  alignSelf = "flex-start",
  marginTop = 0,
  justifyContent = "flex-start",
  marginBottom = 0,
  paddingTop = 24,
  paddingBottom = 24,
  paddingLeft = 24,
  paddingRight = 24,
  backgroundColor = "#fff",
  marginLeft = 0,
  marginRight = 0,
  shadowColor = "rgba(0, 0, 0, 0.1)",
  flexGrow = 1,
  zIndex,
  overflowY = "visible"
  
}) {
  let isBefore = useIsBefore()
  return (<React.Fragment
>
<div
  data-testid="CardBase.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-425sW': typeof width === 'number' ? `${width}px` : width,'--fd-2-425sW': flexDirection,'--as-3-425sW': alignSelf,'--mt-4-425sW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--jc-5-425sW': justifyContent,'--mb-6-425sW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--pt-7-425sW': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pb-8-425sW': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-9-425sW': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-10-425sW': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--bc-11-425sW': backgroundColor,'--ml-12-425sW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-13-425sW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--sc-14-425sW': shadowColor,'--fg-15-425sW': flexGrow,'--zi-17-425sW': zIndex,'--oy-18-425sW': overflowY,'--o-16-425sW': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}